import { storageManager } from '../../../core/storage/index.js';
import { CONFIG_KEY } from './hangout-constants.js';

export const getHangoutConfig = async () => (await storageManager.getItem(CONFIG_KEY)) || {};

export const setHangoutConfig = async (config) => storageManager.setItem(CONFIG_KEY, config);

export const getCharacterDisplayIndex = async (characterId) => {
    if (!characterId) return 0;
    const hangoutConfig = await getHangoutConfig();
    const index = (hangoutConfig.allCharacters || []).findIndex((c) => String(c.id) === String(characterId));
    return index >= 0 ? index : 0;
};

export const getCurrentOutfitForCharacter = async (characterId) => {
    const hangoutConfig = await getHangoutConfig();
    const character = hangoutConfig?.allCharacters?.find((c) => String(c.id) === String(characterId));
    return character?.outfitId != null ? character.outfitId : '0';
};

export const updateHangoutConfigAfterMessage = async (responseData, finalOutfitId) => {
    const config = await getHangoutConfig();
    if (!config.allCharacters?.length) return;
    const char = config.allCharacters.find((c) => String(c.id) === String(responseData.characterId));
    if (char && finalOutfitId != null && char.outfitId !== finalOutfitId) {
        char.outfitId = finalOutfitId;
        await setHangoutConfig(config);
    }
};

export const persistCharacterSpriteMetaInConfig = async (characterId, updates) => {
    const hangoutConfig = await getHangoutConfig();
    const allCharacters = Array.isArray(hangoutConfig.allCharacters) ? hangoutConfig.allCharacters : [];
    let didChange = false;
    hangoutConfig.allCharacters = allCharacters.map((character) => {
        if (String(character?.id) !== String(characterId)) return character;
        didChange = true;
        return {
            ...character,
            ...updates,
            ...(updates.spriteState ? {
                spriteState: { ...(character.spriteState || {}), ...updates.spriteState }
            } : {})
        };
    });
    if (didChange) await setHangoutConfig(hangoutConfig);
};

export const patchCharacterInHangoutConfig = async (characterId, patch) => {
    const hangoutConfig = await getHangoutConfig();
    if (!hangoutConfig?.allCharacters?.length) return;
    const char = hangoutConfig.allCharacters.find((c) => String(c.id) === String(characterId));
    if (!char) return;
    Object.assign(char, patch);
    await setHangoutConfig(hangoutConfig);
};
